import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Link } from 'react-router'
import { BasicForm, InputField } from 'react-serial-forms'
import {
    fetchLoggedInUser,
    loadGeofilterOrganizations,
    loadCoords,
    loadOrganizations,
    loadRegions,
    loadCategoryLPCollection,
    updateRegionFilter,
    flipGlobalFilter
} from '../actions'
import SponsorSlider from '../components/SponsorSlider'
import OrganizationCard from '../components/OrganizationCard'
import { findIndex } from 'lodash/array'
import { CategoryBannerSlider, CategoryConversationSlider } from '../components/CategoryPageSliders'

import CategoryPageBanners from '../components/CategoryPageBanners'

import CategoryPageBoxes from '../components/CategoryPageBoxes'

import { findInBaseStateTree } from '../utils/index'
import { AUTH_COOKIE_PATH } from '../utils/'
import Cookie from 'js-cookie'
import OrganizationsPagination from '../components/OrganizationsPagination'
import ToolTip from '../components/CollageTooltip'
import TooltipSearchForm from '../components/TooltipSearchForm'
import DocumentMeta from 'react-document-meta'
import intros from '../misc/categoryLandingIntros'
import { asyncActions } from 'react-async-actions'


class RegionSidebarNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_tooltip: false
    };
  }

  // If we can get the logged in users region we use that
  // Otherwise we use geolocation to match the closest region
  // with organizations.
  autoSetRegion(regions) {
    return;
    const token = Cookie.get(AUTH_COOKIE_PATH);
    let that = this;
    let flattenedRegions = flattenRegions(regions.regions);

    function regionById(regionId, regions) {
        for(var currentRegion of regions) {
            if(currentRegion.id === regionId) {
                return currentRegion;
            }
        }
        return;
    };

    /*
    this.props.fetchLoggedInUser(token.authToken).then(function(resp) {
      if(resp.type == 'FETCH_USER_FAIL' || !resp.response.data.region) {
        // This will resolve with a lat/long on success
        return that.props.loadCoords();
      } else {
        let region = resp.response.data.region_obj;
        return region ? { 'latitude': region.latitude, 'longitude': region.longitude } : that.props.loadCoords();
      }
      }).then(function(resp) {
        let data;

        if(resp.response) {
            data = resp.response.data;
        } else {
            data = resp;
        }

        let lat = data.latitude,
            long = data.longitude,
            coordsA = {
              'lat': lat,
              'long': long
            },
            shortestPath;



        return that.props.loadGeofilterOrganizations({category: that.props.slug})
          .then(function(organizations) {
            shortestPath = calcShortestRegionPath(
              coordsA,
              regionsWithOrganizations(
                flattenedRegions, organizations
              )
            );
            that.updateRegions(shortestPath.id);
          });
      });
    */
  };

  componentDidMount() {
    let that = this;
    this.props.loadRegions().then((regions) => {
        that.autoSetRegion(regions.response.data);
    });
  }

  componentWillReceiveProps(nextProps) {
    let isSame = this.props.slug == nextProps.slug;
    let that = this;
    if(!isSame) {
        this.props.loadRegions().then((regions) => {
            that.autoSetRegion(regions.response.data);
        });
    }
  }

  updateRegions(region) {
    let isRegionSelected = false;

    for(var currentRegion of this.props.categoryLPFilter.regions) {
      if(currentRegion === region) {
        isRegionSelected = true;
        break;
      }
    }

    if(!isRegionSelected) {
      this.props.updateRegions({
        target: {
          value: region
        }
      });
    }
  };

  handleCheckboxChange = (e) => {
  };

  render() {
    if(!this.props.regions.isLoaded) {
      return <div><i className="fa fa-spinner fa-spin"></i></div>;
    }

    const filteredRegions = this.props.categoryLPFilter.regions || [];

    var liClasses = 'categoryDetail-sidebarRegionNavItem',
        children = '';

    var regions = this.props.regions.regions.map((item) => {
      if(item.children) {
        let filteredChildren = item.children.filter(child => child.level <= 2);

        // Sort child regions by name
        filteredChildren.sort(function(a, b) {
          var nameA = a.name.toLowerCase(), nameB =  b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        children = filteredChildren.map((child) => {
          let checked = { checked: false };

          if(filteredRegions.indexOf(child.id) != -1) {
            checked = { checked: true };
          }

          return <li key={child.id} className={liClasses}>
            <label><input {...checked} onChange={this.props.updateRegions} type="checkbox" name="region" value={child.id} />
              {child.name}</label>
          </li>;
        });

        children = <ul className="categoryDetail-sidebarRegionChildNavList">
          {children}
        </ul>;
      }

      let checked = { checked: false };
      if(filteredRegions.indexOf(item.id) != -1) {
        checked = { checked: true };
      }

      return (
          <li key={item.id} className={liClasses}>
          <label><input {...checked} onChange={this.props.updateRegions} type="checkbox" name="region" value={item.id} />
            {item.name}</label>
          {children}
        </li>
      );

    });

    let globalChecked = { checked: this.props.categoryLPFilter.global };
    return (
      <ul className="categoryDetail-sidebarRegionNavList">
        <li className="categoryDetail-sidebarRegionNavItemHeader filter-by-location">Filter by location
          <div
            onClick={()=>{this.setState({show_tooltip: !this.state.show_tooltip})}}
            className="categoryDetail-sidebarRegionHelp">?<span id="help" style={{position: 'absolute', color: 'rgba(0, 0, 0, 0)', left: '0.9rem', bottom: '-1rem'}}>-</span></div>
        </li>
        <li className={liClasses}>
          <label><input {...globalChecked} onChange={this.props.flipGlobalFilter} type="checkbox" name="global" />Global </label>
        </li>
        <ToolTip
          active={this.state.show_tooltip}
          position="bottom"
          arrow="bottom"
          parent={'#help'}
          tooltipTimeout={0}
          isActiveOnHover={false}
        >
          <TooltipSearchForm onSearch={this.props.onSearch} onCancel={()=>{this.setState({show_tooltip: false})}}/>
        </ToolTip>
        {regions}
      </ul>
    );
  }
} // End RegionSidebarNav


class CategorySidebarNav extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { routeParams } = this.props;
    let secondarySlug = '';
    let slug = '';

    if(routeParams) {
      if(routeParams.secondarySlug) {
        secondarySlug = routeParams.secondarySlug;
        slug = routeParams.slug;
      } else if (routeParams.slug) {
        slug = routeParams.slug;
      }
    }


    var children = '',
        liClass = 'categoryDetail-sidebarCategoryNavItem',
        anchorClasses = 'categoryDetail-sidebarNavCategoryItemAnchor';
    var secondaryAnchorClasses = 'categoryDetail-sidebarNavCategoryItemAnchor';

    var childPathArray = '';
    var lastChildPath = '';

    var itemPathArray = '';
    var lastItemPath = '';

    var nav = this.props.navItems.map((item) => {
      if(item.children) {
        children = item.children.map((child) => {

          childPathArray = child.path.split('/');
          lastChildPath = childPathArray[childPathArray.length - 1];

          if(lastChildPath == slug) {
            anchorClasses = `categoryDetail-sidebarNavCategoryItemAnchor currentlySelected`;
          } else {
            anchorClasses = 'categoryDetail-sidebarNavCategoryItemAnchor';
          }

          let childUrl = `/browse/${child.path}/`;
          return <li key={child.id} key={child.id} className={liClass}>
            <Link key={child.id} onClick={this.props.closeSubMenu} className={anchorClasses} to={childUrl}>{child.name}</Link>
          </li>;
        });

        children = <ul key={item.id} className="categoryDetail-sidebarCategoryChildNavList">
          {children}
        </ul>;
      }

      let itemUrl = `/browse/${item.path}/`;

      if (secondarySlug == '') {
        secondarySlug = slug;
      }

      itemPathArray = item.path.split('/');
      lastItemPath = itemPathArray[itemPathArray.length - 1];

      if(lastItemPath == secondarySlug) {
        secondaryAnchorClasses = 'categoryDetail-sidebarNavCategoryItemAnchor currentlySelected';
      } else {
        secondaryAnchorClasses = 'categoryDetail-sidebarNavCategoryItemAnchor';
      }


      return (
        <li className={liClass}>
          <Link onClick={this.props.closeSubMenu} className={secondaryAnchorClasses} to={itemUrl}>{item.name}</Link>
          {children}
        </li>
      );

    });
      return <ul className="categoryDetail-sidebarCategoryNavList">
            <li className="categoryDetail-sidebarCategoryNavItemHeader">Select a category</li> {nav} </ul>;
  }
} // End CategorySidebarNav


const actionsToFire = (props) => [
    props.loadOrganizations({
        category: props.params.slug,
        region: props.categoryLPFilter.regions,
        global: props.categoryLPFilter.global
    }),
    props.loadCategoryLPCollection(`${props.params.slug}-banner-slider`),
    props.loadRegions()
]


@connect(
  state => (state), // Can be replaced by mapStateToProps function as well.
  {
    push,
    fetchLoggedInUser,
    loadCoords,
    loadOrganizations,
    loadGeofilterOrganizations,
    loadRegions,
    loadCategoryLPCollection,
    updateRegionFilter,
    flipGlobalFilter
  }
)
@asyncActions(actionsToFire)
class CategoryDetail extends Component {
  state = {
    subMenuOpen: false,
    subMenuRegionsOpen: false
  };

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    let isSame = (
      this.props.params.slug == nextProps.params.slug
    );

    if(!isSame) {
      nextProps.loadRegions();
      nextProps.loadOrganizations({
        category: nextProps.params.slug,
        region: nextProps.categoryLPFilter.regions,
        global: nextProps.categoryLPFilter.global
      });
      nextProps.loadCategoryLPCollection(`${nextProps.params.slug}-banner-slider`);
      window.scrollTo(0, 0);
    }
  }

  componentWillMount() {
    this.props.loadOrganizations({
      category: this.props.params.slug,
      region: this.props.categoryLPFilter.regions,
      global: this.props.categoryLPFilter.global
    });
    this.props.loadCategoryLPCollection(`${this.props.params.slug}-banner-slider`);
    this.props.loadRegions();

  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTitleClick = (e) => {
    let newState = {};
    this.setState({ subMenuOpen: !this.state.subMenuOpen });
    this.setState({ subMenuRegionsOpen: false });
    if (this.props.browser.greaterThan.desktop) {
        this.setState({ subMenuOpen: true });
        this.setState({ subMenuRegionsOpen: false });
    }
  };

  closeSubMenu = (e) => {
    this.setState({ subMenuOpen: false });
  };




  // *********** BEGIN: REGION SUBNAV EVENT HANDLERS **********
  handleRegionClick = (e) => {
    let newState = {};
    this.setState({ subMenuRegionsOpen: !this.state.subMenuRegionsOpen });
    this.setState({ subMenuOpen: false });
  };

  closeSubMenuRegions = (e) => {
    this.setState({ subMenuRegionsOpen: false });
  };
  // *********** END: REGION SUBNAV EVENT HANDLERS ************




  flipGlobalFilter = e => {
    this.props.flipGlobalFilter();
    this.props.loadOrganizations({
      category: this.props.params.slug,
      region: this.props.categoryLPFilter.regions,
      global: !this.props.categoryLPFilter.global
    });
  };

  updateRegions = e => {
    this.props.updateRegionFilter(e.target.value);
    this.props.loadOrganizations({
      category: this.props.params.slug,
      region: this.props.categoryLPFilter.regions,
      global: this.props.categoryLPFilter.global
    });
  };

  previousPage = e => {
    e.preventDefault();
    const { previous, count, limit, offset } = this.props.organizations;
    if(previous) {
      this.props.loadOrganizations({
        category: this.props.params.slug,
        region: this.props.categoryLPFilter.regions,
        global: this.props.categoryLPFilter.global,
        limit: limit,
        offset: offset - limit
      });
    }
  }

  nextPage = (e) => {
    e.preventDefault();
    const { next, limit, offset, count } = this.props.organizations;
    if(next) {
      this.props.loadOrganizations({
        category: this.props.params.slug,
        region: this.props.categoryLPFilter.regions,
        global: this.props.categoryLPFilter.global,
        limit: limit,
        offset: offset + limit
      });
    }
  }

  pageJump = (number, e) => {
    const { count, limit, offset } = this.props.organizations;
    const maxOffset =  count - limit;
    let newOffset = number * limit - 10;
    if(newOffset > maxOffset) {
      newOffset = maxOffset;
    }

    this.props.loadOrganizations({
      category: this.props.params.slug,
      region: this.props.categoryLPFilter.regions,
      global: this.props.categoryLPFilter.global,
      limit: limit,
      offset: newOffset
    });
  }



  onSearch(value, e){
    e.preventDefault();
    this.props.push(`/search?q=${value}`);
  }

  render() {

    if (!this.props.organizations.isLoaded) {
      return <span />;
    }

    if (!this.props.baseState.isLoaded) {
      return <span />;
    }

    // ********** BEGIN: Sort Organizations by Name **********
    var orgMap = this.props.organizations.results;

    let rootCategoryName = this.props.organizations.root_category_name;


    /*
    orgMap.sort(function(a, b){
     var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
     if (nameA < nameB) //sort string ascending
      return -1
     if (nameA > nameB)
      return 1
     return 0 //default return value (no sorting)
    });
    */

    // ********** END: Sort Organizations by Name **********

    var organizationList = '';
    var db_id = '';
    organizationList = orgMap.map((item) => {
      return <OrganizationCard user={this.props.auth.user} key={item.db_id} item={item} db_id={item.db_id} />;
    });



    // Determine if page is root or child
    let categoryDepthClass;
    if(this.props.location.pathname) {
      let path = this.props.location.pathname;
      let pathArray = path.split('/');
      if (pathArray[1] == 'browse' && pathArray.length > 3) {
        categoryDepthClass = 'category-child';
      } else {
        categoryDepthClass = 'category-parent';
      }
    }

    if(organizationList.length == 0) {
        let regionNames = this.props.categoryLPFilter.regions.map((regionId) => {
            return findInBaseStateTree(this.props.baseState.regions, regionId);
        });

        // If no orgs returned for selected regions and category hide sponsors
        // and center page title
        categoryDepthClass = categoryDepthClass + ' no-results';

        organizationList = <div className="no-results-wrapper">
          <p>Sorry, we have no results for {this.props.organizations.category_name} {regionNames.join(", ")} yet.</p>
          <p><img src="/images/categories/no_results_lady.jpg" alt="" className="no-results-lady" /></p>
          <p>Help us to build {this.props.organizations.category_name}  {regionNames.join(", ")} by recommending your favorite organizations, programs and services for women.</p>
          <p><Link to={'/my/recommend'} className="category-recommendFavService">Recommend your favorite services </Link></p>
        </div>;
    }




    var categorySidebarNav = '',
        regionsSidebarNav = '',
        mobileRegionsSidebarNav = '';
    const { categories } = this.props.baseState;
    const cid = this.props.organizations.root_category_id;
    var i = findIndex(categories, { id: cid });
    const category = categories[i];


    let org='';

    let contentWidth = '';
    if(this.props.browser.greaterThan.desktop && this.props.baseState.isLoaded) {

      categorySidebarNav = <CategorySidebarNav routeParams={this.props.params} closeSubMenu={this.closeSubMenu} navItems={category.children} />;
      regionsSidebarNav = <RegionSidebarNav
                              onSearch={this.onSearch.bind(this)}
                              categoryLPFilter={this.props.categoryLPFilter}
                              updateRegions={this.updateRegions}
                              flipGlobalFilter={this.flipGlobalFilter}
                              regions={this.props.regions}
                              loadGeofilterOrganizations={this.props.loadGeofilterOrganizations}
                              loadRegions={this.props.loadRegions}
                              loadCoords={this.props.loadCoords}
                              slug={this.props.params.slug}
                              org={this.props.org}
                              fetchLoggedInUser={this.props.fetchLoggedInUser}/>;

    }


    if(this.state.subMenuOpen) {
      categorySidebarNav = <CategorySidebarNav router={this.props.router} closeSubMenu={this.closeSubMenu} navItems={category.children} />;

    }

    if(this.state.subMenuRegionsOpen) {
      mobileRegionsSidebarNav = <RegionSidebarNav
                              onSearch={this.onSearch.bind(this)}
                              categoryLPFilter={this.props.categoryLPFilter}
                              updateRegions={this.updateRegions}
                              flipGlobalFilter={this.flipGlobalFilter}
                              regions={this.props.regions}/>;

    }


    if(this.state.subMenuOpen) {
      categorySidebarNav = <CategorySidebarNav router={this.props.router} closeSubMenu={this.closeSubMenu} navItems={category.children} />;

    }

    if(this.state.subMenuRegionsOpen) {
      mobileRegionsSidebarNav = <RegionSidebarNav
                              onSearch={this.onSearch.bind(this)}
                              categoryLPFilter={this.props.categoryLPFilter}
                              updateRegions={this.updateRegions}
                              flipGlobalFilter={this.flipGlobalFilter}
                              regions={this.props.regions}/>;

    }

    if(this.props.browser.greaterThan.desktop) {
      contentWidth = this.props.browser.width - 250;
      if(this.props.browser.width > 1200) {
        let delta = this.props.browser.width - 1200;
        contentWidth = contentWidth - delta;
      }
    }


    let iconClasses = 'fa fa-chevron-down';
    if(!this.props.browser.greaterThan.desktop && this.state.subMenuOpen) {
      iconClasses = 'fa fa-times-circle';
    }

    let mapIconClasses = 'fa fa-chevron-down';
    if(!this.props.browser.greaterThan.desktop && this.state.subMenuRegionsOpen) {
      mapIconClasses = 'fa fa-times-circle';
    }

    let topTitleMargin = '-5rem';
    if(this.props.browser.greaterThan.tablet) {
      topTitleMargin = 'initial';
    }

    // Hide the page title for mobile category child pages
    let topViewedTitleClass = 'top-viewed';


    let pagination = (
      <OrganizationsPagination organizations={this.props.organizations}
                               pageJump={this.pageJump}
                               nextPage={this.nextPage}
                               previousPage={this.previousPage} />

    );


    const meta = {
      title: 'WorldWideWomen | ' + String(this.props.organizations.category_seo_title || ''),
      description: String(this.props.organizations.category_seo_description || ''),
    }

    return (
      <div className="content-wrapper">
          <DocumentMeta {...meta} />

        <div className={categoryDepthClass}>

          <div className="categoryDetail-inner">

              <CategoryPageBanners browser={this.props.browser} params={this.props.router.params} />

            <div className="categoryDetail-pageTitle">
                <div className="categoryDetail-pageTitle-inner">

                  <div onClick={this.handleTitleClick} className="categoryDetail-pageTitle-wrapper">
                    {this.props.organizations.category_name} <i className={iconClasses}></i>
                  </div>

                  <div onClick={this.handleRegionClick} className="mobileRegions-submenu">
                    <span className="mobileRegions-submenuLocation">Location</span> <i className={mapIconClasses}></i>
                  </div>

                </div>
            </div>

            <div className="categoryDetail-contentWrapper">
              <div className="categoryDetail-sidebar">
                  {categorySidebarNav}
                  {regionsSidebarNav}
                  {mobileRegionsSidebarNav}
              </div>
              <div style={{width: contentWidth+'px'}} className="categoryDetail-organizationsListContainerWrapper">



                <div className="categoryDetail-pageTitleWrapper">

                  <h4 className={topViewedTitleClass}><span className="categoryDetail-categoryPrefix">{rootCategoryName}:</span>   {this.props.organizations.category_name}</h4>
                  {pagination}
                </div>

                <div className="categoryDetail-organizationsListContainer">
                  {organizationList}
                </div>

                <div className="categoryDetail-paginationFooter">
                  {pagination}
                </div>




              </div>
            </div>
            <div className="categoryDetail-inner-clear"></div>
          </div>

        </div>
      </div>
    );
  }
};

/***********************************************
 * Code to auto find closest region below
 ***********************************************/
function getCoordinates() {
    let resp = loadCoords();
    return resp;
};

function toRadians(x) {
  return x*Math.PI/180;
};

/*
  Haversine distance function. Computes 'as the crow flies' distance
  It expects degrees and will convert to radians
*/
function haversine(coordsA, coordsB) {
  let deltaLat = toRadians(coordsA.lat - coordsB.lat),
      deltaLong = toRadians(coordsA.long - coordsB.long),
      latA = toRadians(coordsA.lat),
      latB = toRadians(coordsB.lat),
      longA = toRadians(coordsA.long),
      longB = toRadians(coordsB.long),
      a, d;

  a = Math.sin(deltaLat/2)*Math.sin(deltaLat/2) + Math.cos(latA)*Math.cos(latB)*Math.sin(deltaLong/2)*Math.sin(deltaLong/2);
  d = 2*Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return d;
};

function regionsWithOrganizations(regions, organizations) {
  regions = regions.filter((region) => {
    let hasOrgs = false;

    let regionIds = organizations.map((org) => {
        return org.region_ids;
    });
    regionIds = [].concat.apply([], regionIds);
    regionIds = regionIds.filter((regionId) => {
      return region.id === regionId;
    });
    let result = regionIds.length > 0;
    return result;
  });

  return regions;
};

function calcShortestRegionPath(coords, regions) {
  let shortestPath;
  for(var region of regions) {
    let coordB, d, path;

    coordB = {
      'lat': region.latitude,
      'long': region.longitude
    };

    d = haversine(coords, coordB);
    path = {
      id: region.id,
      name: region.name,
      distance: d
    };
    if(shortestPath) {
      if(shortestPath.distance > d) {
        shortestPath = path;
      }
    } else {
      shortestPath = path;
    }
  }

  return shortestPath;
};

function flattenRegions(regions) {
  function recurse(regions) {
      let flattenedRegions = [];

      regions.map(region => {
        flattenedRegions.push(region);
        if(region.children && region.children.length) {
          flattenedRegions = flattenedRegions.concat(recurse(region.children));
        }
      });

      return flattenedRegions;
  };

  return recurse(regions);
};

export default CategoryDetail



// WEBPACK FOOTER //
// ./src/containers/CategoryDetail.jsx